import React, { forwardRef, MutableRefObject } from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';

export interface TextAreaProps
  extends React.ComponentPropsWithoutRef<'textarea'> {
  invalid?: boolean;
}

const TextArea = styled.textarea<TextAreaProps>`
  border: 1px solid
    ${(props) => (props.invalid ? colours.red : colours.borderLightGrey)};
  border-radius: 5px;
  width: 100%;
  min-height: 100px;
  padding: 12px 20px;
  color: ${colours.greyDarkAl2};

  &:active,
  &:focus {
    outline: none;
    border: 1px solid ${colours.blue};
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colours.greyLightAlt3};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colours.greyLightAlt3};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${colours.greyLightAlt3};
  }
`;

const TextAreaComponent = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    props: TextAreaProps,
    ref:
      | ((instance: HTMLTextAreaElement | null) => void)
      | MutableRefObject<HTMLTextAreaElement | null>
      | null
  ) => <TextArea ref={ref} {...props} />
);

TextAreaComponent.displayName = 'TextInput';

export default TextAreaComponent;
